import { useEffect, useState } from 'react';
import { THEME } from '@/common/styles/theme';

export const useIsMobileViewport = () => {
	const [isMobile, setIsMobile] = useState(() => {
		if (typeof window === 'undefined') {
			return false;
		}

		return window.matchMedia(`(max-width: ${THEME.mobileBreakpoint})`).matches;
	});

	useEffect(() => {
		const mediaQuery = window.matchMedia(`(max-width: ${THEME.mobileBreakpoint})`);
		const handleChange = () => setIsMobile(mediaQuery.matches);

		handleChange();
		mediaQuery.addEventListener('change', handleChange);

		return () => mediaQuery.removeEventListener('change', handleChange);
	}, []);

	return isMobile;
};
